import { getJobSeekerAccountsAsync,
         searchJobSeekerAccountsAsync,
        getEmployerAccountsAsync,
        searchEmployerAccountsAsync} from "@/services/admin/adminService";

export const administrator = {
    namespaced: true,
    state:{
       accounts: null,
    },
    getters:{
        getAccounts(state){
            return state.accounts
        }
    },
    mutations:{
        //For Accounts
        setAccounts(state,accounts){
            state.accounts = accounts;
        },
          updateAccounts(state,account){
            const _account = state.accounts.find(v => v.id === account.id);
            if(_account){
                _account.emailConfirmed = account.emailConfirmed;
                _account.isActive = account.isActive;
                _account.isUnauthorized = account.isUnauthorized;
                _account.subscriptionExpired = account.subscriptionExpired;    
            }
        },
        removeAccount(state,id){
           state.accounts = state.accounts.filter(v => v.id !== id); 
        },
        removeAllAccounts(state){
            state.accounts = [];
        },
        removeAPermanentlyDeletedAccount(state,id){
           state.accounts = state.accounts.filter(v => v.id !== id); 
        },   
  
    },
    actions: {
        //For Job Seekers
        async getJobSeekerAccounts({commit}, page){
            
                   var response = await  getJobSeekerAccountsAsync(page);
                   if(!response.success){
                           const err = new Error(res.message, {reason: response.caption});
                           err.caption = res.caption;
                           throw err;
                       }else{
                
                           commit('setAccounts', response.jobSeekers);
                       }
               },
       
          async searchJobSeekerAccounts({commit}, content){
                    var response = await searchJobSeekerAccountsAsync(content.data,content.page);
                    if(!response.success){
                            if(!response.errors){
                            const err = new Error(response.message, {reason: response.caption});
                            err.caption = response.caption;
                            throw err;
                            }else{
                                var errorMessages = "";
                                console.log(response.errors);
                                for(var error of response.errors){
                                    errorMessages += `${error}<br/>`;
                                }
                                throw new Error(errorMessages, {reason: response.caption})
                            }
                        }else{
                            commit('setAccounts', response.jobSeekers);
                        }
            },

            //For Employers
        async getEmployerAccounts({commit}, page){
            
                   var response = await  getEmployerAccountsAsync(page);
                   if(!response.success){
                           const err = new Error(res.message, {reason: response.caption});
                           err.caption = res.caption;
                           throw err;
                       }else{
                
                           commit('setAccounts', response.employers);
                       }
               },
       
          async searchEmployerAccounts({commit}, content){
                    var response = await searchEmployerAccountsAsync(content.data,content.page);
                    if(!response.success){
                            if(!response.errors){
                            const err = new Error(response.message, {reason: response.caption});
                            err.caption = response.caption;
                            throw err;
                            }else{
                                var errorMessages = "";
                                console.log(response.errors);
                                for(var error of response.errors){
                                    errorMessages += `${error}<br/>`;
                                }
                                throw new Error(errorMessages, {reason: response.caption})
                            }
                        }else{
                            commit('setAccounts', response.employers);
                        }
            },

             updateAccounts({commit}, content){
                commit('updateAccounts', content);
             },
            removeAccount({commit}, content){
                commit('removeAccount', content);
            },
            removeAllAccounts({commit},content){
                commit('removeAllAccounts',content);
            },
            async deleteSelectedJobApplicantAsync({commit}, content){
                            var response = await deleteApplicantAsync(content);
                            if(!response.success){     
                                    const err = new Error(response.message, {reason: response.caption});
                                    err.caption = response.caption;
                                    throw err;
                                }else{
                                    commit(' removeApplicant', content.applicantId);
                            }
            },
            removeAPermanentlyDeletedApplicant({commit}, content){
                commit('removeAPermanentlyDeletedApplicant', content);
            },

            async deleteAllJobApplicantsAsync({commit}, content){ // content: jobId
                            var response = await deleteAllApplicantsAsync(content);
                            if(!response.success){     
                                    const err = new Error(response.message, {reason: response.caption});
                                    err.caption = response.caption;
                                    throw err;
                                }else{
                                    commit('removeAllApplicants');
                            }
            },

         
    }
}